// extracted by mini-css-extract-plugin
export default {"success":"ABUPfFY7yTWP5xjmPsGyHw==","successIcon":"vaYXo9ObpV64BPuzbHa8PQ==","priceCta":"otzmidp+q2Xj4lVx6QkxXg=="};